export default {
  eyebrow: 'Portale partner',
  title: 'Branding',
  description: "L'aspetto del tuo portale white-label e della pagina di accesso.",
  page: {
    read_only_notice: 'Sola lettura. Clicca Modifica per cambiare un valore.',
    editing_notice: 'Modifica in corso — le modifiche sono visibili al tuo team e ai clienti.',
  },
  branding: {
    scope_hint:
      'Si applica al tuo portale white-label e alla pagina di accesso — non ai negozi dei tuoi ristoranti, che hanno un branding per ristorante.',
    upload: 'Carica logo',
    logo: {
      label: 'Logo',
      hint: 'Mostrato sulle tue superfici white-label.',
    },
    circle_logo: {
      label: 'Favicon / logo circolare',
      hint: 'Logo quadrato usato come favicon e avatar. Opzionale — può essere rimosso.',
    },
    splash_image: {
      label: 'Immagine di accesso',
      hint: 'Mostrata nella tua pagina di accesso white-label. Consigliata: almeno 1200px di larghezza. Opzionale — può essere rimossa.',
    },
    footer_note: 'Ulteriori opzioni di branding (colori secondari) disponibili in seguito.',
  },
  form: {
    primary_color: {
      label: 'Colore brand principale',
      hint: 'Personalizza il tuo portale partner e la pagina di accesso.',
    },
    dashboard_subdomain: {
      label: 'Slug di accesso partner',
      hint: 'Slug in minuscolo — identifica il tuo brand nel link di accesso del team (?partner=…).',
      placeholder: 'nome-partner',
    },
    login_url: {
      label: 'Link di accesso del team',
      hint: 'Condividi questo link con il tuo team — apre la pagina di accesso con il tuo branding.',
    },
    file: {
      label: 'Immagine',
    },
  },
  login_url_warning: {
    title: 'Cambiare il link di accesso del team?',
    description:
      'Il link di accesso del team cambierà in {{url}}. Condividi il nuovo link da ora — quello vecchio non mostrerà più il tuo brand.',
    description_no_url:
      'Il link di accesso del team cambierà. Condividi il nuovo link da ora — quello vecchio non mostrerà più il tuo brand.',
  },
  login_url_changed: {
    title: 'Link di accesso del team modificato',
    description: 'Il tuo team accede ora su {{url}}. Salva il nuovo link come segnalibro e condividilo con il team.',
  },
  buttons: {
    edit: 'Modifica',
    cancel: 'Annulla',
    save: 'Salva',
  },
  toasts: {
    load_error: 'Impossibile caricare il branding.',
    failed_to_save_changes: 'Salvataggio modifiche non riuscito',
    changes_got_saved: 'Modifiche salvate',
    logo_uploaded: 'Logo caricato',
    logo_upload_failed: 'Caricamento del logo non riuscito',
    logo_removed: 'Logo rimosso',
    logo_remove_failed: 'Rimozione del logo non riuscita',
    file_too_large: 'File troppo grande. La dimensione massima è {{max}} MB.',
    image_too_narrow: "L'immagine di accesso deve essere larga almeno {{min}}px.",
  },
};
